import { AppBar, makeStyles, styled } from "@material-ui/core";
import { Linked, useIO, useLinked, useModel } from "@type-r/react";
import { Button, Column, Columns, Flex, Loading, Page, SelectSortBy, TilesList, Toolbar } from "lqx-react";
import * as React from "react";
import { useMemo } from "react";
import { CreditNoteVaultCard } from "../api/CreditNoteVaultCard";
import { CreditNotesVaultPage } from "../api/creditNotesVaultPage";
import { AddFilter } from "../components/search-bar/search-bar";
import { CountListSection } from "../count-list-section";
import { CreditNoteDetailsPane } from "./credit-note-details-pane";
import { CreditNoteVaultCardRenderer } from "./credit-note-vault-card-renderer";
import { SortOptions } from "./models/credit-notes-filters";
import { CreditNotesStore } from "./models/credit-notes-store";

export const CreditNotesPage = () => {
    var classes = useStyles();
    const state = useModel(CreditNotesStore);
    const [isReady, setIsReady] = React.useState(false);
    const creditNoteVaultPage = useModel(CreditNotesVaultPage);
    const $activeCreditNoteCard: Linked<CreditNoteVaultCard> = useLinked<CreditNoteVaultCard>(null);
    const $selectedCreditNoteDetailsTab = useLinked("details");
    const [countAll, setCountAll] = React.useState(0);

    useIO(async () => {
        await Promise.all([
            state.buyers.fetch(),
            state.suppliers.fetch()
        ])
        state.initialize()
        await getData();
        setCountAll(creditNoteVaultPage.creditNotes.count);
    }, [])

    const getData = async () => {
        const params = state.filter.mapToQuery(0, 1000);
        await creditNoteVaultPage.creditNotes.fetch({ params: params }).catch(e => console.error(e));
        setIsReady(true);
    };

    useMemo(async () => {
        if (isReady) {
            setIsReady(false);
            $activeCreditNoteCard.set(null);
            await getData()
        }
    }, [state.filter['_changeToken']]);

    const closeDetailsPane = () => $activeCreditNoteCard.set(null);
    const onVaultCardClicked = () => $selectedCreditNoteDetailsTab.set('details');

    return <>
        <Page maxWidth={false} header={
            <Flex center>
                <h4 className={classes.title}>Credit Notes</h4>
            </Flex>
        }
            top={
                <AppBar position="static" color="secondary">
                    <Toolbar>
                        <StyledFilterBar filter={state.filter} filterAllPlaceholder="Filter by Buyer, Supplier, Currency, Amount, or Issuance Date (yyyy-mm-dd)" />
                        {/* <StateFilter stateValue={ state.filter.$.stateId } filterOptions={ CreditNoteStateOptions } /> */}
                        <SelectSortBy $attr={state.filter.sortBy.$.attr} $asc={state.filter.sortBy.$.asc} options={SortOptions} />
                    </Toolbar>
                </AppBar>
            }>

            {
                isReady ?
                    <Columns style={{ minHeight: 'calc(100% - 80px)' }}>
                        <TilesListColumn>
                            <CountListSection countAll={countAll} countFiltered={creditNoteVaultPage.creditNotes.count}></CountListSection>
                            <TilesList
                                items={creditNoteVaultPage.creditNotes.items.models}
                                itemSize={100}
                                renderer={CreditNoteVaultCardRenderer($activeCreditNoteCard, null, onVaultCardClicked)}
                                selected={undefined}
                            />
                        </TilesListColumn>
                        {$activeCreditNoteCard.value &&
                            <CreditNoteDetailsPaneColumn>
                                <CreditNoteDetailsPane close={closeDetailsPane} creditNote={$activeCreditNoteCard.value.dataset} creditNoteId={$activeCreditNoteCard.value.id} $selectedTab={$selectedCreditNoteDetailsTab} />
                            </CreditNoteDetailsPaneColumn>}
                    </Columns> : <Loading />
            }
        </Page>
    </>
};

const useStyles = makeStyles({
    title: {
        padding: '20px 0',
        color: '#3d6889',
        fontSize: '24px'
    }
});

const TilesListColumn = styled(Column)({
    minWidth: '500px',
    minHeight: '250px',
});

const SendToButton = styled(Button)({
    marginTop: '10px',
    height: '23px',
    borderRadius: '50px',
    padding: '5px, 10px, 5px, 10px',
    fontFamily: 'Montserrat',
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '13px',
    letterSpacing: '0px',
    textAlign: 'center',
    disabled: 'true'
});

const StyledFilterBar = styled(AddFilter)({
    width: '650px',
    alignItems: 'center',
    padding: '4px',
})

const CreditNoteDetailsPaneColumn = styled(Column)({
    minWidth: '250px'
});
